var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 36,
    viewBox: "0 0 90 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.2106H13.3417L22.4281 18.5688L34.2619 19.2173L34.5321 20.5141L35.883 20.0818L37.6121 23.1078L48.5273 23.5401L60.0909 35.3199L61.766 34.9416L65.1703 34.6714L66.251 33.9149L66.1429 31.2672L67.0615 32.1858L69.7093 28.6735L74.8427 25.0531L78.5711 24.1345L79.868 24.6749L79.9761 23.5401L80.7325 24.3506L83.1101 21.7569L80.5164 21.1625L77.3823 22.2973L75.0588 19.7576L78.2469 21.2166L80.6785 19.4874L78.9494 19.3794L80.9487 18.1906L81.435 17.4341L79.0034 17.1639L77.7606 16.0292L76.3016 15.813L75.383 14.5162L79.8139 16.0292L79.5438 14.6783H80.5164L80.7325 16.0832L81.9754 15.759L82.894 16.6235L84.6772 16.9478L87.9733 13.2733L89 10.4635L87.7572 9.54488L86.6765 10.0852L86.3522 12.3007L85.7579 12.5709L85.4877 11.0038L86.0821 9.1126L83.6505 8.84242L83.3263 9.65295L82.4077 8.78839L78.9494 9.22067L78.5711 8.3561L78.3009 6.19468L79.0574 4.62764L79.2736 7.81574L80.4083 8.3561L81.7592 7.86978L81.3269 6.19468L83.2722 7.27539L83.0561 6.19468L84.6231 7.00521L85.4336 6.51889L84.2989 4.73571L86.5684 6.19468L86.6224 5.00589L87.2709 5.60028L87.6491 5.11396L85.92 2.62832L86.7305 2.25008L86.9466 1.54761L27.9198 1L27.4642 4.10613L26.3874 4.02329L23.9854 7.25366L22.6187 6.38396L18.9327 8.91028L18.1044 7.66784L15.3296 9.57293L14.7084 11.3124L13.0932 11.1881L9.69717 14.1286L7.12944 13.7559L4.39604 15.4125L3.52633 17.6903L1.12425 18.0216L1 21.2106Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNc);
export default __webpack_public_path__ + "static/media/NC.4670ff31dcaa29c163ab618aeb93ad93.svg";
export { ForwardRef as ReactComponent };